export default __webpack_public_path__ + "static/media/Montserrat-Regular.e20d5327.ttf";